module.exports = __webpack_public_path__ + "static/media/debt-student-v4.a564e02f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/debt-student-v4.svg
// module id = 83
// module chunks = 0